'use strict';

/* Controllers */

app.controller('CognitoRegisterController', ['$http','$scope', '$rootScope', '$location', 'Auth', 'AwsCognito', 'User', 'Popup', 'Helper', 'Preloader','env_config',
    function ($http, $scope, $rootScope, $location, Auth, AwsCognito, User, Popup, Helper, Preloader, env_config) {

        Auth.redirectIfLoggedIn();

        // init scope vars
        $scope.email     = '';
        $scope.username  = '';
        $scope.password  = '';
        $scope.password2 = '';
        $scope.avatar    = '';

        $scope.birthday = {
            day   : '',
            month : '',
            year  : ''
        };

        $scope.email_regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        /**
         * called when user submits registration form
         */
        $scope.registerUser = function() {

            var self = this;

            Preloader.open();

            // prepare user object
            var user = {
                username: $scope.username,
                email:    $scope.email,
                password: $scope.password,
                password_confirmation: $scope.password2,
                sex:      $scope.gender || '',
                dob:      $scope.getFormatedBirthday(),
                ava:      $scope.avatar,
                cognito_identity_id : "",
                cognito_id_token:     ""
            };

            AwsCognito.register(user, function(err, result){

                if(err){
                    if (err == 'UsernameExistsException: User already exists')
                        Popup.error('The username you requested is not available.');
                    else 
                        Popup.error(err);
                    Preloader.close();
                    return;
                }

                // register api
                Auth.verifyRegister(user, function(resp, status) {
                    if(status == 200){

                        AwsCognito.login(user.username, user.password, false, function(resp, status, verifyLoginData){
                            if( status == 200 ) {

                                AwsCognito.setCredentials(verifyLoginData, resp.data.user);

                                // get credit
                                User.getCredit(function(){

                                    // this will go to intended or landing page
                                    Auth.redirectIfLoggedIn();
                                });
                            }
                            else if( status == 500 ){
                                Popup.error('Something went wrong :(');
                            }
                            else if(resp.data.error == true) {

                                // get errors
                                var errors = self.showErrorfromAPI(resp);
                                Popup.error(errors);
                            }
                        });
                        
                        Preloader.close();
                    } else if( status == 500 ){
                            Popup.error('Something went wrong :(');
                    }
                    else if(resp.data.error == true) {
                        // get errors
                        var errors = self.showErrorfromAPI(resp);
                        Popup.error(errors);
                    }
                    Preloader.close();
                });
            });
        }


        /**
         * signup with facebook
         */
        $scope.facebookSignup = function(){
            Preloader.open();
            FB.login(function (response) {
                // Check if the user logged in successfully.
                if (response.authResponse) {
                    if (response.authResponse.grantedScopes.indexOf('email') == -1) {
                        Preloader.close();
                        Popup.error('Sorry, we are not able to retrieve your email address. Please check your Facebook settings.');
                    }
                    else {
                        AwsCognito.fbConnect(response.authResponse.accessToken, false, function(resp, status){
                            Preloader.close();
                            if( status == 200 ){
                               var cognitoData = {
                                    'id_token': resp.data.user.cognito_id_token,
                                    'fb_token': resp.data.user.fb_token
                                };
                                // success
                                AwsCognito.setCredentials(cognitoData, resp.data.user);

                                // get credit
                                User.getCredit(function(){
                        
                                    // this will go to intended or landing page
                                    Auth.redirectIfLoggedIn();
                                });
                            }
                            else if( status == 500 ){
                                Popup.error('Facebook Login has not been supported yet');
                            }
                            else  {
                                Popup.error(resp.data.message);
                            }
                        });
                    }
                } else {
                    //Popup.error(Helper.getProperty(resp, 'data.message'));
                     Preloader.close();
                }

            }, {
                scope: 'email',
                return_scopes: true
            });
        }



        /**
         * previrew avatar after selection
         * 
         * @param  event
         * @param  files
         */
        $scope.previewAvatar = function(event, files){
            var input = event.target;

            if (input.files && input.files[0]) {
                var reader = new FileReader();
                
                reader.onload = function (e) {
                    $scope.$apply(function() {
                        $('.file-upload img').attr('src', e.target.result);
                    });
                }
                
                reader.readAsDataURL(input.files[0]);
            }
        }


        /**
         * show validatyion errors in popup on click
         */
        $scope.showValidationErrors = function(){
            var errors = [];

            // angular scope vars are undefined until they are valid
            // so we have to do a stupid workaround
            var avatar    = $('input[type=file]').val();
            var email     = $('input[name=email]').val();
            var username  = $('input[name=username]').val();
            var password  = $('input[name=password]').val();
            var password2 = $('input[name=password2]').val();


            // check email
            if( email == '' )                   errors.push('Email field is required.');
            else
                if( $scope.registerForm.email.$invalid ) errors.push('You have entered an invalid email address.');

            // check username
            if( username.length < 4 )           errors.push('Username must have at least 4 characters.');
            else 
                if( username.length > 18 )      errors.push('Username cannot be longer than 18 characters.');
                else if( $scope.registerForm.username.$invalid ) errors.push('You have entered an invalid username.');

            // check password
            if( password.length < 6 )           errors.push('Password must have at least 6 characters.');
            else
                if( password.length > 18 )      errors.push('Password cannot be longer than 18 characters.');

            // check password with confirm password
            if( password != password2 )         errors.push('Password and confirm password fields does not match.');

            if( errors.length > 0 ){
                Popup.error(errors);
            }
        }


        /**
         * get values for birthday dropdown
         */
        $scope.selects = {
            days: function() {
                // Get number of days based on month + year 
                // (January = 31, February = 28, April = 30, February 2000 = 29) or 31 if no month selected yet
                var nbDays = new Date($scope.birthday.year, $scope.birthday.month, 0).getDate() || 31;

                var daysList = [];
                for (var i = 1; i <= nbDays; i++) {
                    var iS = i.toString();
                    daysList.push((iS.length < 2) ? '0' + iS : iS); // Adds a leading 0 if single digit
                }
                return daysList;
            },
            months: function() {
                var monthList = [];
                for (var i = 1; i <= 12; i++) {
                    var iS = i.toString();
                    monthList.push((iS.length < 2) ? '0' + iS : iS); // Adds a leading 0 if single digit
                }
                return monthList;
            },
            years: function() {
                var yearsList = [];
                var endYear = new Date().getFullYear()-18;
                var startYear = new Date().getFullYear()-100;

                for (var i = endYear; i >= startYear; i--) {
                    yearsList.push(i.toString());
                }
                return yearsList;
            }
        }


        /**
         * get formated birthday
         */
        $scope.getFormatedBirthday = function(){

            if( $scope.birthday.year != '' && $scope.birthday.month != '' && $scope.birthday.day != '' ){
                return $scope.birthday.year+'-'+$scope.birthday.month+'-'+$scope.birthday.day;
            }

            return '';
        }


        /**
         * show error from api server
        * **/
        $scope.showErrorfromAPI = function(result){

            var errors = [];
            if( result.data.message instanceof Object ){
                angular.forEach(result.data.message, function(value, key) {

                    switch( value[0] ){
                        case 'The ava field is required.':
                            errors.push('We need your pic so your friend knows who sent this fabulous gift.');
                            break;

                        default: errors.push(value[0]);
                    }
                });
            }
            else{
                errors.push(result.data.message);
            }

            return errors;
        }
        
        $scope.googleSignup = function() {
            /**
             * The Sign-In client object.
             */
            var auth2;

            /**
             * Initializes the Sign-In client.
             */
            var initClient = function() {
                gapi.load('auth2', function(){
                    /**
                     * Retrieve the singleton for the GoogleAuth library and set up the
                     * client.
                     */
                    auth2 = gapi.auth2.getAuthInstance();
                    if (!auth2) {
                        auth2 = gapi.auth2.init({
                            client_id: env_config.google_app_id
                        });
                    }
                    
                    console.log('G Signup');

                    // Attach the click handler to the sign-in button
                    auth2.attachClickHandler('customGoogleBtn', {}, onSuccess, onFailure);
                });
            };

            /**
             * Handle successful sign-ins.
             */
            var onSuccess = function(user) {
                Preloader.open();
                var idToken = user.getAuthResponse().id_token;
                var accessToken = user.getAuthResponse().access_token;
                 AwsCognito.ggConnect(idToken, false, accessToken, function(resp, status){
                    Preloader.close();
                    if( status == 200 ){
                        var cognitoData = {
                            id_token: resp.data.user.cognito_id_token,
                            gg_token: resp.data.user.gg_token
                        };

                        // success
                       AwsCognito.setCredentials(cognitoData, resp.data.user);

                        // set cognito credentials
                        //AwsCognito.setCredentials(cognitoData);

                        // get credit
                        User.getCredit(function(){
                
                            // this will go to intended or landing page
                            Auth.redirectIfLoggedIn();
                        });
                    }
                    else if( status == 500 ){
                        Popup.error('Google Login has not been supported yet');
                    }
                    else {
                        Popup.error(resp.data.message);
                    }
                });
             };

            /**
             * Handle sign-in failures.
             */
            var onFailure = function(error) {
                 Preloader.close();
                 //Popup.error(error);
            };

            initClient();
        }

        $scope.googleSignup();
    }]);